import { useQuery } from '@tanstack/react-query';
import { dashboardAPI } from '../services/api';
import type { StatsSummary } from '../types/serverData';
import { dashboardKeys } from './keys';
import { toDashboardChartData, type DashboardStats } from '../utils/dashboardStats';

const emptyStats: StatsSummary = {
  lastSnapshot: { data: {} },
  snapshots: [],
};

export const useStatsSummary = () =>
  useQuery({
    queryKey: dashboardKeys.stats(),
    queryFn: async ({ signal }) => {
      const data = await dashboardAPI.getStatsSummary({ signal });
      return data ?? emptyStats;
    },
    select: (data): DashboardStats => ({
      lastSnapshot: data.lastSnapshot ?? { data: {} },
      chartData: toDashboardChartData(data.snapshots),
    }),
  });
